export function FoundingMessage() {
    return (
        <div className="flex flex-col items-center">
            <div className="flex flex-col items-center w-4/5 md:w-3/5 xl:w-2/5 2xl:w-2/6">
                <span className="uppercase text-5xl">
                    Founding Message
                </span>

                <span className="text-2xl mt-6">
                    Solana Slugs was incepted by the mind of Wafflez in early August of 2021. He had heard about NFTs from his former roommate Xaz, and the two began talks of creating a project to spread Wafflez' art out into the aether.
                </span>

                <span className="text-2xl mt-8">

                    Originally drawing knights, Wafflez grew bored and started fiddling around - sketching up absurd creations such as a slug with a pair of breasts. Seeing the resulting creations, he knew this had to be it.
                </span>

                <span className="text-2xl mt-8">
                    Xaz recruited the aid of Zpalmtree - a dev with several years of experience. The two had met in the Discord of a privacy coin many years before, and had since broken away to form their own server of friends. Now they had someone to set up their Candy Machine.
                </span>

                <span className="text-2xl mt-8">
                    Over time, the team grew larger. Additional friends from the Discord server joined, such as Slorg and Buggles, and the team even found a new member from within the community - TS.
                </span>

                <span className="text-2xl mt-8">
                    Solana Slugs launched on October 23rd, 2021 as one of the few successful free mints in the Solana NFT Space. This choice was made due to their belief that projects should stand or fall on their own merits, and not be rewarded so heavily up front. Many projects have come and gone since those early October days, yet Solana Slugs has stood the test of time - and will continue doing so for many years to come.
                </span>
            </div>
        </div>
    );
}
